import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../../cc-base.component';
import {FormRichFieldConfig} from '../../../../model/api/form-rich-field-config';
import {FormFieldConfig} from '../../../../model/api/form-field-config';
import TYPE = FormFieldConfig.TYPE;
import {CcSubDetailBaseComponent} from "../cc-sub-detail-base.component";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cc-readonly-map-field[fieldName][formRecordMap]',
  templateUrl: './readonly-map-field.component.html',
  styleUrls: ['./readonly-map-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ]
})
export class ReadonlyMapFieldComponent extends CcSubDetailBaseComponent {

  formRichFieldConfig: FormRichFieldConfig;

  @Input()
  fieldName: String;

  formRecords: any[] = [];
  @Input()
  formRecordMap: {};

  @Input()
  transPartKey: string;

  fieldValueMap = {};

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private confirmationService: ConfirmationService) {
    super(cdref, messageService, translateService);
  }

  ngOnInit() {
    this.formRichFieldConfig = {
      fieldId: 'key',
      fieldName: 'key',
      tableConfigs: [
        {
          field: 'key',
          width: 200
        },
        {
          label: '=',
          width: 30
        },
        {
          field: 'value',
          width: 200
        }
      ],
      fields: []
    }
  }

  protected postInitConfigs() {
    super.postInitConfigs();
    this.loadMap();
  }

  loadMap() {
    this.formRecords = [];
    for (let formRecordMapKey in this.formRecordMap) {
      this.formRecords.push({'key': formRecordMapKey, 'value': this.formRecordMap[formRecordMapKey]});
    }
  }

  reloadFieldValueMap() {
    this.loadMap();
    this.fieldValueMap = {};
    if (this.formRichFieldConfig?.tableConfigs && this.formRecordMap)
      this.formRichFieldConfig.tableConfigs.forEach((conf, index) => {
        if (conf?.format?.includes('#'))
          conf.format = '1.0-7';
        Object.keys(this.formRecordMap).forEach((key, indexRec) => {
          if (conf.mapId) {
            const value = conf.mapId(this.formRecordMap[key]);
            this.fieldValueMap['mapId-' + index + '_' + indexRec] = value;
          }
        });
      });
    super.reloadFieldValueMap();
  }
}

